import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { APPLICATION_PATHS } from '../../application-core/constants';
import BasicLangChip from '../../core/BasicLangChip';
import withGS from '../../core/withGShoc';
import GS from '../../grafsync/grafsync';
import { getNewTabLink } from '../utils/utils';

const loadOptions = {};

class TypeLink extends React.Component {

    handleDeleteLink = () => {
        if (this.props.onDeleteIRI) {
            this.props.onDeleteIRI(this.props.id);
        }
        else {
            GS.deleteProperty(this.props.source, this.props.sourceGraph, this.props.property, this.props.id);
        }
    };

    handleClick = (event) => {
        const projectIRI = "https://grafsync.graphifi.com/data" + this.props.graph.substring(this.props.graph.indexOf("/graph") + 6);
        const ontologyIRI = this.props.data.visibility || this.props.data.isDefinedBy;
        let link;
        if (ontologyIRI) {
            link = APPLICATION_PATHS.ONTOLOGY_MANAGER + '/project/ontology#project=' + projectIRI
                + "&ontology=" + ontologyIRI + "&view=class&class=" + this.props.id;
        }
        if (link) {
            if (event.ctrlKey) {
                getNewTabLink(link);
                return;
            }
            this.props.history.push(link);
        }
    };

    render() {

        const { data, defaultLang, viewLang, isReadOnly } = this.props;

        return (
            <BasicLangChip
                id={data.id}
                viewLang={viewLang}
                isReadOnly={isReadOnly}
                defaultLang={defaultLang}
                label={data.label}
                onClick={this.handleClick}
                onDelete={this.handleDeleteLink} />
        );
    }
}

TypeLink.defaultProps = {
    isReadOnly: false,
    property: "type"
};

TypeLink.propTypes = {
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    property: PropTypes.string,
    history: PropTypes.object,
    graph: PropTypes.string.isRequired,
    onDeleteIRI: PropTypes.func,
    source: PropTypes.string,
    sourceGraph: PropTypes.string,
    isReadOnly: PropTypes.bool,
    viewLang: PropTypes.string,
    defaultLang: PropTypes.string.isRequired
};

export default withRouter(withGS(TypeLink, ["ALL"], ["id", "label", "isDefinedBy", "visibility"], loadOptions));